module.exports = __webpack_public_path__ + "img/playing.fc6f32ea.gif";